/* HTML教材(article.html-article)専用ランタイム。
 *
 * 含むもの:
 *   1. Try it(このコードを実行 / 自分で書いて試す)
 *   2. コード/プロンプト例のコピー
 *   3. 固定順の無限スクロール(前方=自動 / 後方=ボタン)
 *   4. サイドバーの現在地同期
 *
 * 依存なし。テーマの既存 JS(infinite-article.js 等)とは無関係に動く。
 * このファイルは snippets/html-article-assets.liquid からのみ読み込む。
 */
(function () {
  "use strict";

  /* handle / 章キー / トラック ID はすべて [a-z0-9-] に正規化済み。
     属性セレクタへ入れる前に必ずこれで検証し、セレクタ注入を防ぐ。
     page_id は site-index の論理IDなので区切りの _ も許す。 */
  var SAFE_KEY = /^[a-z0-9][a-z0-9-]*$/;
  var PAGE_ID_KEY = /^[a-z0-9_][a-z0-9_-]{0,199}$/;

  /* ══════════════════════════════════════════════════════════
     1. Try it
     ══════════════════════════════════════════════════════════ */

  var TRYIT_SELECTOR = "pre.code-block[data-tryit]";
  var TRYIT_SOURCE = "html-tutor-tryit-v1";
  var TRYIT_PREFIX = "html-tutor-tryit:v1:";
  var tryitSeq = 0;

  function hashText(value) {
    var hash = 2166136261;
    for (var i = 0; i < value.length; i += 1) {
      hash ^= value.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36);
  }

  function storageKey(pre, initialCode) {
    var explicit = pre.getAttribute("data-tryit-key");
    if (explicit) return TRYIT_PREFIX + explicit;
    /* data-tryit-key は export_shopify が handle 込みで付ける。無い場合だけ
       所属記事から導く。無限スクロールで複数記事が同一 DOM に載るため、
       document 全体ではなく **その pre を含む記事** を見る。 */
    var entry = pre.closest("[data-hta-entry]");
    var articleKey = entry && entry.getAttribute("data-handle");
    return TRYIT_PREFIX + (articleKey || "article") + ":" + hashText(initialCode);
  }

  function sandboxFor(code) {
    var values = ["allow-scripts"];
    if (/\b(alert|confirm|prompt)\s*\(/.test(code)) values.push("allow-modals");
    if (/target\s*=\s*["']_blank["']|window\.open\s*\(/i.test(code)) values.push("allow-popups");
    /* 学習者のコードへストアのオリジンを渡す sandbox 値は決して足さない。
       渡すと iframe 内のコードが同一オリジンとして動き、localStorage や
       Cookie に到達する。テストがこのファイル全体を文字列検査するため、
       禁止値そのものをコメントにも書かない。 */
    return values.join(" ");
  }

  function cspMeta() {
    return '<meta http-equiv="Content-Security-Policy" content="' + [
      "default-src 'none'",
      "base-uri 'none'",
      "object-src 'none'",
      "frame-src 'none'",
      "form-action 'none'",
      "connect-src 'none'",
      "img-src data: blob: https:",
      "media-src data: blob: https:",
      "font-src data:",
      "style-src 'unsafe-inline' https:",
      "script-src 'unsafe-inline'"
    ].join("; ") + '">';
  }

  function monitorScript(token) {
    var safeToken = JSON.stringify(token).replace(/</g, "\\u003c");
    return "<script>(function(){" +
      "var token=" + safeToken + ";" +
      "function send(kind,value){parent.postMessage({source:'" + TRYIT_SOURCE +
      "',token:token,kind:kind,value:String(value||'')},'*')}" +
      "addEventListener('error',function(e){send('error',e.message||'実行エラー')});" +
      "addEventListener('unhandledrejection',function(e){" +
      "send('error',e.reason&&e.reason.message||e.reason||'Promiseエラー')});" +
      "addEventListener('DOMContentLoaded',function(){send('ready','')});" +
      "})();<" + "/script>";
  }

  function securedSource(code, token) {
    var additions = cspMeta() + monitorScript(token);
    if (/<head(?:\s[^>]*)?>/i.test(code)) {
      return code.replace(/<head(?:\s[^>]*)?>/i, function (head) { return head + additions; });
    }
    var doctype = code.match(/^\s*<!doctype[^>]*>/i);
    if (doctype) return code.replace(doctype[0], doctype[0] + "<head>" + additions + "</head>");
    return "<head>" + additions + "</head>" + code;
  }

  function status(ui, message, isError) {
    ui.status.textContent = message || "";
    ui.status.classList.toggle("is-error", Boolean(isError));
    ui.status.setAttribute("role", isError ? "alert" : "status");
  }

  function makeFrame(id, title, className) {
    var frame = document.createElement("iframe");
    frame.id = id;
    frame.className = "html-tutor-tryit__frame " + className;
    frame.setAttribute("title", title);
    frame.setAttribute("referrerpolicy", "no-referrer");
    frame.setAttribute("loading", "lazy");
    frame.setAttribute("tabindex", "0");
    return frame;
  }

  function render(ui, frame, code) {
    var token = ui.id + "-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
    frame.setAttribute("sandbox", sandboxFor(code));
    frame.setAttribute("data-tryit-token", token);
    frame.removeAttribute("data-tryit-error");
    try {
      frame.srcdoc = securedSource(code, token);
      status(ui, "プレビューを更新しています", false);
    } catch (error) {
      status(ui, "プレビューを更新できません: " + (error.message || error), true);
    }
  }

  function setExpanded(button, expanded, label) {
    button.setAttribute("aria-expanded", expanded ? "true" : "false");
    button.textContent = label;
  }

  function closeReadonly(ui) {
    if (ui.readonlyFrame) ui.readonlyFrame.remove();
    ui.readonlyFrame = null;
    setExpanded(ui.runButton, false, "▶ このコードを実行(Try it)");
  }

  function closeEditor(ui) {
    if (ui.playground) ui.playground.remove();
    ui.playground = null;
    setExpanded(ui.editButton, false, "✎ 自分で書いて試す");
  }

  function readSaved(ui) {
    try {
      return window.localStorage.getItem(ui.storageKey);
    } catch (error) {
      status(ui, "保存済みコードを読み込めません: " + (error.message || error), true);
      return null;
    }
  }

  function save(ui, code) {
    try {
      window.localStorage.setItem(ui.storageKey, code);
    } catch (error) {
      status(ui, "編集内容を保存できません: " + (error.message || error), true);
    }
  }

  function clearSaved(ui) {
    try {
      window.localStorage.removeItem(ui.storageKey);
    } catch (error) {
      status(ui, "保存内容を削除できません: " + (error.message || error), true);
    }
  }

  function openReadonly(ui) {
    if (ui.readonlyFrame) {
      closeReadonly(ui);
      status(ui, "プレビューを閉じました", false);
      return;
    }
    closeEditor(ui);
    var frame = makeFrame(ui.id + "-run", "コードの実行プレビュー", "html-tutor-tryit__readonly");
    ui.readonlyFrame = frame;
    ui.bar.insertBefore(frame, ui.status);
    ui.runButton.setAttribute("aria-controls", frame.id);
    setExpanded(ui.runButton, true, "× プレビューを閉じる");
    render(ui, frame, ui.initialCode);
  }

  function openEditor(ui) {
    if (ui.playground) {
      closeEditor(ui);
      status(ui, "エディタを閉じました", false);
      return;
    }
    closeReadonly(ui);
    var playground = document.createElement("div");
    playground.id = ui.id + "-editor";
    playground.className = "html-tutor-tryit__playground";

    var tools = document.createElement("div");
    tools.className = "html-tutor-tryit__tools";
    var reset = document.createElement("button");
    reset.type = "button";
    reset.className = "html-tutor-tryit__reset";
    reset.textContent = "リセット";
    reset.setAttribute("aria-label", "編集内容を最初のコードに戻す");
    tools.appendChild(reset);

    /* CodeMirror 等へ差し替えられるよう、素の textarea のままにしておく。 */
    var editor = document.createElement("textarea");
    editor.className = "html-tutor-tryit__editor";
    editor.setAttribute("aria-label", "編集するHTMLコード");
    editor.setAttribute("aria-describedby", ui.status.id);
    editor.setAttribute("autocomplete", "off");
    editor.setAttribute("autocapitalize", "off");
    editor.setAttribute("spellcheck", "false");
    editor.setAttribute("wrap", "off");
    editor.spellcheck = false;
    var saved = readSaved(ui);
    editor.value = saved === null ? ui.initialCode : saved;

    var frame = makeFrame(ui.id + "-live", "編集中のコードのライブプレビュー", "html-tutor-tryit__live");
    playground.appendChild(tools);
    playground.appendChild(editor);
    playground.appendChild(frame);
    ui.bar.insertBefore(playground, ui.status);
    ui.playground = playground;
    ui.editButton.setAttribute("aria-controls", playground.id);
    setExpanded(ui.editButton, true, "× エディタを閉じる");
    render(ui, frame, editor.value);

    var timer = 0;
    editor.addEventListener("input", function () {
      save(ui, editor.value);
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { render(ui, frame, editor.value); }, 250);
    });
    editor.addEventListener("keydown", function (event) {
      if (event.key !== "Tab" || event.altKey || event.ctrlKey || event.metaKey) return;
      event.preventDefault();
      var start = editor.selectionStart;
      var end = editor.selectionEnd;
      editor.setRangeText("  ", start, end, "end");
      editor.dispatchEvent(new Event("input", { bubbles: true }));
    });
    reset.addEventListener("click", function () {
      window.clearTimeout(timer);
      editor.value = ui.initialCode;
      clearSaved(ui);
      render(ui, frame, ui.initialCode);
      editor.focus();
      status(ui, "最初のコードに戻しました", false);
    });
    editor.focus();
  }

  function initTryItBlock(pre) {
    if (pre.getAttribute("data-tryit-initialized") === "v1") return;
    var code = pre.querySelector("code");
    if (!code) return;
    pre.setAttribute("data-tryit-initialized", "v1");
    tryitSeq += 1;
    var id = "html-tutor-tryit-" + tryitSeq;

    var bar = document.createElement("div");
    bar.className = "html-tutor-tryit";
    bar.setAttribute("role", "group");
    bar.setAttribute("aria-label", "HTMLコードを試す");

    var runButton = document.createElement("button");
    runButton.type = "button";
    runButton.className = "html-tutor-tryit__run";
    runButton.setAttribute("aria-expanded", "false");
    runButton.textContent = "▶ このコードを実行(Try it)";

    var editButton = document.createElement("button");
    editButton.type = "button";
    editButton.className = "html-tutor-tryit__edit";
    editButton.setAttribute("aria-expanded", "false");
    editButton.textContent = "✎ 自分で書いて試す";

    var liveStatus = document.createElement("p");
    liveStatus.id = id + "-status";
    liveStatus.className = "html-tutor-tryit__status";
    liveStatus.setAttribute("role", "status");
    liveStatus.setAttribute("aria-live", "polite");
    liveStatus.setAttribute("aria-atomic", "true");

    bar.appendChild(runButton);
    bar.appendChild(editButton);
    bar.appendChild(liveStatus);
    pre.insertAdjacentElement("afterend", bar);

    var ui = {
      id: id,
      bar: bar,
      runButton: runButton,
      editButton: editButton,
      status: liveStatus,
      initialCode: code.textContent,
      storageKey: storageKey(pre, code.textContent),
      readonlyFrame: null,
      playground: null
    };
    runButton.addEventListener("click", function () { openReadonly(ui); });
    editButton.addEventListener("click", function () { openEditor(ui); });
  }

  function initTryIt(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(TRYIT_SELECTOR)) initTryItBlock(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(TRYIT_SELECTOR), initTryItBlock);
  }

  /* プロンプト/コード例のコピーボタン。Try itとは別の既存マークアップを扱う。 */
  var COPY_SELECTOR = ".ta-inline-copy-code";

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement("textarea");
      area.value = text;
      area.setAttribute("readonly", "readonly");
      area.style.position = "fixed";
      area.style.top = "-1000px";
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try { ok = document.execCommand("copy"); } catch (error) { ok = false; }
      document.body.removeChild(area);
      if (ok) resolve(); else reject(new Error("copy failed"));
    });
  }

  function initCopyBlock(box) {
    if (box.getAttribute("data-hta-copy-ready") === "true") return;
    var button = box.querySelector(".ta-code-copy");
    var statusNode = box.querySelector(".ta-code-copy-status");
    var source = box.querySelector(".ta-code-copy-source");
    var code = box.querySelector("pre code");
    if (!button || !(source || code)) return;
    box.setAttribute("data-hta-copy-ready", "true");

    var timer = null;
    function copyStatus(message) {
      if (statusNode) statusNode.textContent = message;
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (statusNode) statusNode.textContent = "";
      }, 2400);
    }

    button.addEventListener("click", function () {
      var value = source ? source.value : code.textContent;
      copyText(value).then(function () {
        copyStatus("コピーしました");
      }, function () {
        copyStatus("コピーできませんでした");
      });
    });
  }

  function initCopy(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    if (scope.matches && scope.matches(COPY_SELECTOR)) initCopyBlock(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(COPY_SELECTOR), initCopyBlock);
  }

  /* スマホでは、追従バー左の「目次」からサイドバーをドロワー表示する。 */
  function initSideDrawer() {
    var article = document.querySelector("[data-html-article]");
    if (!article || article.getAttribute("data-hta-side-ready") === "true") return;
    var toggle = article.querySelector("[data-hta-side-toggle]");
    var overlay = article.querySelector("[data-hta-side-overlay]");
    var side = article.querySelector(".html-article__side");
    if (!toggle || !side) return;
    article.setAttribute("data-hta-side-ready", "true");
    var savedRootOverflow = "";
    var lastFocus = null;
    var sideDetails = side.querySelector(".html-article__side-details");
    var savedDetailsOpen = false;

    function drawerFocusables() {
      return Array.prototype.slice.call(side.querySelectorAll(
        'summary, a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (node) { return node.getClientRects().length > 0; });
    }

    function setOpen(open, restoreFocus) {
      var wasOpen = article.hasAttribute("data-hta-side-open");
      if (open) {
        lastFocus = document.activeElement;
        if (sideDetails) { savedDetailsOpen = sideDetails.open; sideDetails.open = true; }
        savedRootOverflow = document.documentElement.style.overflow;
        article.setAttribute("data-hta-side-open", "true");
        document.documentElement.style.overflow = "hidden";
        side.setAttribute("role", "dialog");
        side.setAttribute("aria-modal", "true");
        side.setAttribute("aria-label", "教材の目次");
        side.setAttribute("tabindex", "-1");
        window.requestAnimationFrame(function () {
          var nodes = drawerFocusables();
          var currentLink = side.querySelector('a[aria-current="page"]');
          var focusTarget = currentLink || nodes[0];
          if (focusTarget) {
            try { focusTarget.focus({ preventScroll: true }); }
            catch (error) { focusTarget.focus(); }
          }
          /* focusによるブラウザ既定スクロールより後に、現在地へ合わせる。 */
          scheduleSidebarAlignment(primaryEntry());
        });
      } else {
        article.removeAttribute("data-hta-side-open");
        if (sideDetails && wasOpen) sideDetails.open = savedDetailsOpen;
        document.documentElement.style.overflow = savedRootOverflow;
        side.removeAttribute("role");
        side.removeAttribute("aria-modal");
        side.removeAttribute("aria-label");
        side.removeAttribute("tabindex");
        if (restoreFocus && lastFocus && lastFocus.focus) lastFocus.focus();
      }
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (overlay) overlay.hidden = !open;
    }

    toggle.addEventListener("click", function () {
      var opening = !article.hasAttribute("data-hta-side-open");
      setOpen(opening, !opening);
    });
    if (overlay) overlay.addEventListener("click", function () { setOpen(false, true); });
    document.addEventListener("keydown", function (event) {
      if (!article.hasAttribute("data-hta-side-open")) return;
      if (event.key === "Escape") {
        setOpen(false, true);
        return;
      }
      if (event.key === "Tab") {
        var nodes = drawerFocusables();
        if (!nodes.length) { event.preventDefault(); side.focus(); return; }
        var first = nodes[0];
        var last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    });
    side.addEventListener("click", function (event) {
      if (event.target.closest("a")) setOpen(false, false);
    });
    if (window.matchMedia) {
      var wide = window.matchMedia("(min-width: 901px)");
      var onWide = function (mq) { if (mq.matches) setOpen(false, false); };
      if (wide.addEventListener) wide.addEventListener("change", onWide);
      else if (wide.addListener) wide.addListener(onWide);
    }
  }

  window.addEventListener("message", function (event) {
    var data = event.data;
    if (!data || data.source !== TRYIT_SOURCE || !data.token) return;
    var frames = document.querySelectorAll("iframe[data-tryit-token]");
    for (var i = 0; i < frames.length; i += 1) {
      var frame = frames[i];
      if (frame.getAttribute("data-tryit-token") !== data.token) continue;
      if (event.source !== frame.contentWindow) continue;
      var bar = frame.closest(".html-tutor-tryit");
      var target = bar && bar.querySelector(".html-tutor-tryit__status");
      if (!target) return;
      /* 一度エラーになった frame は、後続の ready で緑に戻さない。 */
      if (data.kind !== "error" && frame.getAttribute("data-tryit-error") === "true") return;
      if (data.kind === "error") frame.setAttribute("data-tryit-error", "true");
      target.textContent = data.kind === "error" ? "実行エラー: " + data.value : "プレビューを更新しました";
      target.classList.toggle("is-error", data.kind === "error");
      target.setAttribute("role", data.kind === "error" ? "alert" : "status");
      return;
    }
  });

  /* ══════════════════════════════════════════════════════════
     2. 無限スクロール(固定順)
     ══════════════════════════════════════════════════════════ */

  var VIEW = "html-article-stream";
  var STREAM_OK = "[data-hta-stream-ok]";
  var ENTRY_SEL = "[data-hta-entry]";
  var MAX_ENTRIES = 30;      /* DOM に載せる記事数の上限(iframe とメモリの保険) */
  var FETCH_TIMEOUT = 12000;
  var PRELOAD_PX = 1200;

  var root = document.querySelector("[data-html-article]");
  var loadedHandles = Object.create(null);
  var fetchCache = Object.create(null);
  var streamMutationPending = false;

  function entries() {
    return root ? Array.prototype.slice.call(root.querySelectorAll(ENTRY_SEL)) : [];
  }

  function say(message) {
    var node = root && root.querySelector("[data-hta-status]");
    if (!node) return;
    node.textContent = message || "";
    node.hidden = !message;
  }

  function showRetry(show) {
    var button = root && root.querySelector("[data-hta-retry]");
    if (button) button.hidden = !show;
  }

  function streamUrl(handle) {
    var url = new URL("/blogs/" + root.dataset.blog + "/" + handle, location.origin);
    url.searchParams.set("view", VIEW);
    return url.href;
  }

  /* 取得した記事断片を DOM へ入れる前に整える。
     - 上へ挿す記事の画像は eager にする。lazy のままだと挿入後に読み込みが
       走って高さが変わり、スクロール補正がずれる(=画面が飛ぶ)。 */
  function prepareNode(node, eager) {
    Array.prototype.forEach.call(node.querySelectorAll("img"), function (img) {
      img.removeAttribute("fetchpriority");
      img.setAttribute("loading", eager ? "eager" : "lazy");
      if (!img.hasAttribute("decoding")) img.setAttribute("decoding", "async");
    });
    return node;
  }

  function fetchEntry(handle) {
    if (!SAFE_KEY.test(handle)) return Promise.reject(new Error("不正な handle"));
    if (!fetchCache[handle]) {
      var controller = new AbortController();
      var timer = window.setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT);
      fetchCache[handle] = fetch(streamUrl(handle), {
        credentials: "same-origin",
        headers: { "X-Requested-With": "html-article" },
        signal: controller.signal
      }).then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.text();
      }).finally(function () {
        window.clearTimeout(timer);
      }).catch(function (error) {
        delete fetchCache[handle];
        throw error;
      });
    }
    return fetchCache[handle].then(function (text) {
      var doc = new DOMParser().parseFromString(text, "text/html");
      /* ?view= は存在しない値でも 200 で別テンプレートを返す。
         判別子が無い応答は「別物」として捨てる(フルページ挿入の事故防止)。 */
      if (!doc.querySelector(STREAM_OK)) throw new Error("stream 応答ではありません");
      var entry = doc.querySelector(ENTRY_SEL);
      if (!entry) throw new Error("記事断片がありません");
      if (entry.getAttribute("data-handle") !== handle) throw new Error("handle 不一致");
      return document.importNode(entry, true);
    }).catch(function (error) {
      delete fetchCache[handle];
      throw error;
    });
  }

  /* ── サイドバー同期 ── */

  function sidebarNav() {
    return document.querySelector("[data-hts]");
  }

  /* 検証用コピーは本番記事と handle が異なる。site-index の論理 page_id を
     第一キーにし、metafield 未投入の旧記事だけ handle へフォールバックする。 */
  function sidebarPage(nav, entry) {
    if (!nav || !entry) return null;
    var pageId = entry.getAttribute("data-page-id") || "";
    var rows;
    var i;
    if (PAGE_ID_KEY.test(pageId)) {
      rows = nav.querySelectorAll(".hts__page[data-page-id]");
      for (i = 0; i < rows.length; i += 1) {
        if (rows[i].getAttribute("data-page-id") === pageId) return rows[i];
      }
    }
    var handle = entry.getAttribute("data-handle") || "";
    if (!SAFE_KEY.test(handle)) return null;
    return nav.querySelector('.hts__page[data-handle="' + handle + '"]');
  }

  function sidebarScrollContainer(nav) {
    if (!nav) return null;
    var side = nav.closest(".html-article__side");
    if (!side) return null;
    var article = side.closest("[data-html-article]");
    var mobile = window.matchMedia && window.matchMedia("(max-width: 900px)").matches;
    if (mobile) {
      /* 閉じたdrawerには寸法が無い。開いた直後にもう一度同期する。 */
      return article && article.hasAttribute("data-hta-side-open") ? side : null;
    }
    return nav.closest(".html-article__side-inner");
  }

  function fitsBelow(container, context, pageRow) {
    if (!container || !context || !pageRow) return false;
    var contextRect = context.getBoundingClientRect();
    var pageRect = pageRow.getBoundingClientRect();
    return pageRect.bottom - contextRect.top <= Math.max(0, container.clientHeight - 16);
  }

  /* 画像3と同じく現在trackを上端へ置く。長いtrackで現在ページが画面内に
     入らない場合だけchapter、さらに長ければpageへ狭める。scrollIntoViewは
     window本文まで動かし得るので、対象containerのrect差分だけを加算する。 */
  function alignSidebar(entry) {
    var nav = sidebarNav();
    var container = sidebarScrollContainer(nav);
    if (!container || container.clientHeight <= 0) return;
    var pageRow = sidebarPage(nav, entry);
    var chapter = nav.querySelector(".hts__chapter--current");
    var track = nav.querySelector(".hts__track--current");
    var target = track || chapter || pageRow;
    if (pageRow && track && !fitsBelow(container, track, pageRow)) {
      target = chapter && fitsBelow(container, chapter, pageRow) ? chapter : pageRow;
    }
    if (!target) return;
    var containerRect = container.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var contentTop = containerRect.top + (container.clientTop || 0) + 8;
    var delta = targetRect.top - contentTop;
    if (Math.abs(delta) > 1) container.scrollTop += delta;
  }

  var sidebarAlignmentRequest = 0;
  function scheduleSidebarAlignment(entry) {
    if (!entry) return;
    var requestId = ++sidebarAlignmentRequest;
    window.requestAnimationFrame(function () {
      if (requestId !== sidebarAlignmentRequest) return;
      alignSidebar(entry);
    });
  }

  function syncSidebar(entry) {
    var nav = sidebarNav();
    if (!nav) return;
    var chapter = entry.getAttribute("data-chapter") || "";
    var track = entry.getAttribute("data-track") || "";

    Array.prototype.forEach.call(nav.querySelectorAll('a[aria-current="page"]'), function (a) {
      a.removeAttribute("aria-current");
    });
    Array.prototype.forEach.call(nav.querySelectorAll(".hts__chapter--current"), function (li) {
      li.classList.remove("hts__chapter--current");
    });

    var pageRow = sidebarPage(nav, entry);
    var link = pageRow && pageRow.querySelector("a");
    if (link) link.setAttribute("aria-current", "page");
    if (SAFE_KEY.test(chapter)) {
      var li = nav.querySelector('.hts__chapter[data-chapter="' + chapter + '"]');
      if (li) li.classList.add("hts__chapter--current");
    }
    Array.prototype.forEach.call(nav.querySelectorAll(".hts__track"), function (details) {
      var isCurrent = details.getAttribute("data-track") === track;
      details.classList.toggle("hts__track--current", isCurrent);
      if (isCurrent) details.open = true;
    });
    scheduleSidebarAlignment(entry);
  }

  /* トラックを跨いだときだけサイドバーを差し替える。
     サイドバーは「全トラックの章 + 現在トラックの全ページ」なので、
     同一トラック内の移動では取得が要らない(17回しか起きない処理)。 */
  var sidebarRequest = 0;
  function ensureSidebarTrack(entry) {
    var holder = document.querySelector("[data-hts-track]");
    var track = entry.getAttribute("data-track") || "";
    if (!holder) return;
    if (holder.getAttribute("data-hts-track") === track) return;
    var handle = entry.getAttribute("data-handle") || "";
    if (!SAFE_KEY.test(handle)) return;
    var requestId = ++sidebarRequest;
    fetch("/blogs/" + root.dataset.blog + "/" + handle, { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.text() : Promise.reject(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, "text/html");
        if (!doc.querySelector("[data-html-article]")) return;
        var fresh = doc.querySelector("[data-hts]");
        var freshHolder = doc.querySelector("[data-hts-track]");
        var current = sidebarNav();
        if (requestId !== sidebarRequest || entry.getAttribute("data-handle") !== currentHandle) return;
        if (!fresh || !freshHolder || !current || freshHolder.getAttribute("data-hts-track") !== track) return;
        current.replaceWith(document.importNode(fresh, true));
        holder.setAttribute("data-hts-track", track);
        syncSidebar(entry);
      })
      .catch(function () { /* 差し替えに失敗しても章単位の強調は効いている */ });
  }

  /* ── 現在地(primary)の確定 ── */

  var currentHandle = null;
  var initialHandle = null;

  function primaryEntry() {
    var all = entries();
    for (var i = 0; i < all.length; i += 1) {
      if (all[i].getAttribute("data-handle") === currentHandle) return all[i];
    }
    return all.length ? all[0] : null;
  }

  /* 入口記事以外には計測用の ?n=<入口からの相対位置>&e=<入口handle> を付ける。
     前の記事は負、次の記事は正、入口そのものは0(クリーンURL)に保つ。
     canonical等は変更せず、緊急時はセクション設定で一括停止できる。 */
  function displayUrl(entry) {
    var url = entry.getAttribute("data-url");
    if (!url) return null;
    if (!root || root.getAttribute("data-url-params") !== "true") return url;
    var all = entries();
    var initialIndex = all.findIndex(function (item) {
      return item.getAttribute("data-handle") === initialHandle;
    });
    var entryIndex = all.indexOf(entry);
    if (initialIndex < 0 || entryIndex < 0) return url;
    var n = entryIndex - initialIndex;
    if (n === 0) return url;
    var initial = initialHandle;
    if (!initial || !SAFE_KEY.test(initial)) return url;
    return url + (url.indexOf("?") >= 0 ? "&" : "?")
      + "n=" + n + "&e=" + encodeURIComponent(initial);
  }

  function commitPrimary(entry) {
    var handle = entry.getAttribute("data-handle");
    if (!handle || handle === currentHandle) return;
    currentHandle = handle;
    var title = entry.getAttribute("data-title");
    var url = displayUrl(entry);
    if (title) {
      try { document.title = title; } catch (error) { /* noop */ }
    }
    if (url) {
      /* replaceState にする。pushState だと戻るボタンがスクロール量ぶん
         積み上がった履歴を1つずつ遡ることになり、離脱できなくなる。 */
      try { history.replaceState(history.state, "", url); } catch (error) { /* noop */ }
    }
    syncSidebar(entry);
    ensureSidebarTrack(entry);
  }

  /* ── 前方(自動) ── */

  var appending = false;
  var appendCount = 0;

  function tailEntry() {
    var all = entries();
    return all.length ? all[all.length - 1] : null;
  }

  function headEntry() {
    var all = entries();
    return all.length ? all[0] : null;
  }

  function appendNext() {
    if (appending || streamMutationPending || !root) return;
    var tail = tailEntry();
    if (!tail) return;
    var next = tail.getAttribute("data-next") || "";
    if (!next) { say("これが最後の教材です"); stopSentinel(); return; }
    if (loadedHandles[next]) {
      say("教材の並びに循環があるため、読み込みを停止しました");
      stopSentinel();
      return;
    }
    if (entries().length >= MAX_ENTRIES) {
      say("読み込みの上限に達しました。続きは各ページから読めます");
      stopSentinel();
      return;
    }
    appending = true;
    streamMutationPending = true;
    showRetry(false);
    say("次の教材を読み込んでいます…");
    fetchEntry(next).then(function (node) {
      var sentinel = root.querySelector("[data-hta-sentinel]");
      sentinel.parentNode.insertBefore(prepareNode(node, false), sentinel);
      loadedHandles[next] = true;
      initTryIt(node);
      initCopy(node);
      observeEntry(node);
      appendCount += 1;
      if (!("IntersectionObserver" in window)) {
        if (node.getAttribute("data-next")) {
          say("");
          showRetry(true);
        } else {
          showRetry(false);
          say("これが最後の教材です");
        }
      } else {
        say("");
        if (latched) startObservers();
      }
    }).catch(function (error) {
      say("次の教材を読み込めませんでした: " + (error && error.message ? error.message : error));
      stopSentinel();
      showRetry(true);
    }).finally(function () {
      appending = false;
      streamMutationPending = false;
    });
  }

  /* ── 後方(ボタン) ──
     自動の上方向ロードは、読んでいる位置が勝手に動くのと区別が付かず
     操作不能になりやすい。明示クリックにする。 */

  var prepending = false;

  function updateBackButton() {
    var button = root && root.querySelector("[data-hta-back]");
    if (!button) return;
    var head = headEntry();
    var prev = head && head.getAttribute("data-prev");
    button.hidden = !prev;
  }

  function prependPrev() {
    if (prepending || streamMutationPending || !root) return;
    var head = headEntry();
    if (!head) return;
    var prev = head.getAttribute("data-prev") || "";
    if (!prev) { updateBackButton(); return; }
    if (loadedHandles[prev]) {
      say("教材の並びに循環があるため、前方読み込みを停止しました");
      updateBackButton();
      return;
    }
    if (entries().length >= MAX_ENTRIES) {
      say("読み込みの上限に達しました");
      return;
    }
    prepending = true;
    streamMutationPending = true;
    var button = root.querySelector("[data-hta-back]");
    if (button) { button.disabled = true; button.textContent = "読み込んでいます…"; }

    fetchEntry(prev).then(function (node) {
      prepareNode(node, true);
      /* 高さ補正は **アンカー要素の位置差** で行う。
         document.scrollHeight の差分では合わない。挿入によって既存記事に
         `.html-article__entry + .html-article__entry` の margin/padding/border が
         付き、その増分が「アンカーより上に増えた量」と一致しないため
         (実測: scrollHeight 差 3919px に対し、実際に上へ増えたのは 3886px)。

         読んでいた記事の viewport 上の位置を直接保つこの方式なら、
         Try it バーの挿入・戻るボタンの消失・記事間マージンの発生を
         まとめて吸収できる。測定〜挿入〜補正の間に await を挟まないこと。 */
      var beforeTop = head.getBoundingClientRect().top;
      head.parentNode.insertBefore(node, head);
      loadedHandles[prev] = true;
      initTryIt(node);
      initCopy(node);
      updateBackButton();
      var afterTop = head.getBoundingClientRect().top;
      window.scrollTo({ top: window.scrollY + (afterTop - beforeTop), behavior: "instant" });
      observeEntry(node);
      say("");
    }).catch(function (error) {
      say("前の教材を読み込めませんでした: " + (error && error.message ? error.message : error));
    }).finally(function () {
      prepending = false;
      streamMutationPending = false;
      if (button) { button.disabled = false; button.textContent = "↑ 前の教材を読み込む"; }
      updateBackButton();
    });
  }

  /* ── 監視 ── */

  var sentinelObserver = null;
  var primaryObserver = null;

  function stopSentinel() {
    if (sentinelObserver) sentinelObserver.disconnect();
    sentinelObserver = null;
  }

  function observeEntry(entry) {
    if (primaryObserver) primaryObserver.observe(entry);
  }

  function start() {
    /* Try it は無限スクロールに依存しない。[data-html-article] が無い
       描画(セクションのフォールバック枝・テスト用の素の HTML)でも動かす。 */
    initTryIt(document);
    initCopy(document);
    initSideDrawer();
    if (!root) return;

    var first = headEntry();
    if (first) {
      currentHandle = first.getAttribute("data-handle");
      initialHandle = currentHandle;
      syncSidebar(first);
    }
    entries().forEach(function (entry) {
      var handle = entry.getAttribute("data-handle") || "";
      if (SAFE_KEY.test(handle)) loadedHandles[handle] = true;
    });

    var backButton = root.querySelector("[data-hta-back]");
    if (backButton) backButton.addEventListener("click", prependPrev);
    var retryButton = root.querySelector("[data-hta-retry]");
    if (retryButton) retryButton.addEventListener("click", function () {
      showRetry(false);
      appendNext();
    });
    updateBackButton();

    if (!("IntersectionObserver" in window)) {
      if (first && first.getAttribute("data-next")) showRetry(true);
      return;
    }
    addLatchListeners();
  }

  /* クローラーのレンダリング中に別記事を自動追加しないよう、UAが生成した
     実操作(isTrusted)が初めて起きてからObserverを開始する。 */
  var latched = false;
  var LATCH_EVENTS = ["pointerdown", "touchstart", "wheel", "keydown", "click"];

  function removeLatchListeners() {
    LATCH_EVENTS.forEach(function (type) {
      window.removeEventListener(type, latch, { capture: true });
    });
  }

  function latch(event) {
    if (latched || !event || event.isTrusted !== true) return;
    latched = true;
    removeLatchListeners();
    startObservers();
  }

  function addLatchListeners() {
    LATCH_EVENTS.forEach(function (type) {
      window.addEventListener(type, latch, { passive: true, capture: true });
    });
  }

  function startObservers() {
    if (!root) return;
    if (!primaryObserver) {
      primaryObserver = new IntersectionObserver(function (records) {
        records.forEach(function (record) {
          if (record.isIntersecting) commitPrimary(record.target);
        });
      }, { rootMargin: "-20% 0px -70% 0px", threshold: 0 });
      entries().forEach(observeEntry);
    }

    var sentinel = root.querySelector("[data-hta-sentinel]");
    if (!sentinel || sentinelObserver) return;
    sentinelObserver = new IntersectionObserver(function (records) {
      if (records.some(function (record) { return record.isIntersecting; })) appendNext();
    }, { rootMargin: "0px 0px " + PRELOAD_PX + "px 0px", threshold: 0 });
    sentinelObserver.observe(sentinel);
  }

  /* 公開 API。
     appendNext / prependPrev は通常 sentinel とボタンから呼ばれるが、
     手動でも叩けるようにしておく。IntersectionObserver は
     **非表示タブでは配信されない**(描画フレームが無いため)ので、
     ヘッドレス検証ではここから直接呼んで前後の追記を確認する。 */
  window.HtmlArticle = {
    initTryIt: initTryIt,
    initCopy: initCopy,
    initSideDrawer: initSideDrawer,
    syncSidebar: syncSidebar,
    appendNext: appendNext,
    prependPrev: prependPrev,
    entries: entries
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  document.addEventListener("shopify:section:load", function (event) {
    initTryIt(event.target);
    initCopy(event.target);
    initSideDrawer();
  });
})();
